// src/components/utils/ReportWrapper.tsx
import React from 'react';
import { useLocation } from 'react-router-dom';

interface ReportWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper para páginas de reportes que fuerza un remontaje completo cuando cambia la URL.
 * Esto permite recargar el reporte cuando el usuario hace clic en la misma opción del menú.
 */
export const ReportWrapper: React.FC<ReportWrapperProps> = ({ children }) =>
{
  const location = useLocation();

  // El key se basa en pathname + search, lo que fuerza un remontaje cuando cambia cualquiera de los dos
  const key = location.pathname + location.search;

  return (
    <div key={key} style={{ height: '100%', minHeight: 0 }}>
      {children}
    </div>
  );
};
